import { createRoot } from 'react-dom/client';
import { Root } from './Root';
import { initSentry } from './sentry';
import { registerServiceWorker } from './registerServiceWorker';
import { следитьЗаВозвращением } from './data/dbReconnect';
import './ui/styles.css';

/** Точка входа: только проводка, ни одного обещания.
 *
 *  Дерево приложения вместе с границей ошибок и последним рубежом живёт в
 *  `Root.tsx` — там его исполняет прогон. Здесь остаются побочные действия,
 *  которых в прогоне быть не должно, и монтирование. */
initSentry();
registerServiceWorker();
/** Только здесь, а не в прогоне: подписка живёт на `document`, и заводить её
 *  нужно ровно один раз на фактическую установку приложения в браузере, а
 *  не в тесте `Root.tsx`. Отписка не нужна: страница живёт, пока живёт
 *  вкладка. */
следитьЗаВозвращением();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Не найден элемент #root');
}

createRoot(rootElement).render(<Root />);
